export const FETCH_EXPENSES_PREPAID = 'DETALIZATION_NEW:FETCH_EXPENSES_PREPAID';
export const FETCH_EXPENSES_PREPAID_SUCCESS = 'DETALIZATION_NEW:FETCH_EXPENSES_PREPAID_SUCCESS';
export const FETCH_EXPENSES_PREPAID_ERROR = 'DETALIZATION_NEW:FETCH_EXPENSES_PREPAID_ERROR';
export const FETCH_EXPENSES_PREPAID_SERVER_ERROR = 'DETALIZATION_NEW:FETCH_EXPENSES_PREPAID_SERVER_ERROR';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const UI_DATE_FORMAT = 'DD.MM.YY';
